module.exports = __webpack_public_path__ + "static/img/krp975-653-370gld.152fe92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/krp975-653-370gld.jpg
// module id = BkxL
// module chunks = 0